@if (global.data.isLoading) {
<div class="report-wrapper ion-padding">
<h2 class="no-data">Loading...</h2>
</div>
}

@if (!isDataExist && !global.data.isLoading) {
<div class="report-wrapper ion-padding">
<h2 class="no-data">No data for this Site</h2>
</div>
}

@if (isDataExist) {
<div class="report-wrapper">
<div>
@if (!isDataExist) {
<h2
  class="no-data"
>
  No Follow Up Notes added yet
</h2>
}
@if (followUpNotes.flow.length) {
<div class="data-header">Flow</div>
}
@for (flow of followUpNotes.flow; track flow) {
<div>
  <ion-grid>
    <ion-row>
      <ion-col>
        @if (flow.isCategoryVisible) {
        <h2>{{flow.templateCategoryOrder}}. {{flow.templateCategoryName}}</h2>
        }
        <p>{{flow.question}}</p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <div class="question-answer-wrapper">
          @if (flow.answer==='Compliant') {
          <div class="answer green">
            <div>
              <ion-icon name="checkmark-circle"></ion-icon>
              Compliant
            </div>
          </div>
          }
          @if (flow.answer==='N/C') {
          <div class="answer red">
            <div>
              <ion-icon name="warning"></ion-icon>
              N/C
            </div>
          </div>
          }
          @if (flow.answer==='N/A') {
          <div class="answer orange">
            <div>
              <ion-icon name="ban"></ion-icon>
              N/A
            </div>
          </div>
          }
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-list>
          @for (comment of flow.comments; track comment) {
          <ion-item class="ion-no-padding">
            <ion-label class="ion-text-wrap">{{comment.comment}}</ion-label>
                    </ion-item>
          }
        </ion-list>
      </ion-col>
    </ion-row>
    @if (flow.note?.typeOfNote === 'Internal Note') {
    <ion-row>
      <ion-col size="12">
        <div class="note">
          Note
          <p>{{flow.note.note}}</p>
                  </div>
                </ion-col>
              </ion-row>
    }
  </ion-grid>
  @if (isFollowUpControlsBlockVisible && flow.note?.typeOfNote === 'Internal Note') {
  <div>
    @if (!flow.note.isCompleted) {
  <button class="green"
          (click)="completeUncheckFollowUpNote(flow.note, true, flow.isPreviousVisit)"
          [disabled]="global.data.isLoading">
    <ion-icon name="checkmark-circle"></ion-icon>
    Mark as Completed
  </button>
  }
  @if (flow.note.isCompleted) {
  <button class="red"
          (click)="completeUncheckFollowUpNote(flow.note, false, flow.isPreviousVisit)"
          [disabled]="global.data.isLoading">
    <ion-icon name="ban"></ion-icon>
    Uncheck
  </button>
  }
  </div>
  }
  @for (n of flow.additionalNotes; track n) {
  <ion-grid class="notes-grid">
    <ion-row>
      <ion-col size="12">
        @if (n.img) {
  <ion-img
    class="note-picture"
    [src]="n.img"
    alt="{{n.note}}"
  ></ion-img>
  }
  @if (isShowImageShareButton && n.filename) {
  <button class="red share-button" (click)="share(n)">
    <ion-icon name="share-social"></ion-icon>
  </button>
  }
  <div class="note">
    Note
    <p>{{n.note}}</p>
                  </div>
                </ion-col>
              </ion-row>
              @if (isFollowUpControlsBlockVisible) {
  <ion-row>
    <ion-col>
      <div>
        @if (!n.isCompleted) {
        <button class="green"
          (click)="completeUncheckFollowUpNote(n, true, flow.isPreviousVisit)"
          [disabled]="global.data.isLoading">
          <ion-icon name="checkmark-circle"></ion-icon>
          Mark as Completed
        </button>
        }
        @if (n.isCompleted) {
        <button class="red"
          (click)="completeUncheckFollowUpNote(n, false, flow.isPreviousVisit)"
          [disabled]="global.data.isLoading">
          <ion-icon name="ban"></ion-icon>
          Uncheck
        </button>
        }
      </div>
    </ion-col>
  </ion-row>
  }
  </ion-grid>
  }
</div>
}
@if (followUpNotes.siteInventory.length) {
<div class="data-header">Site inventory</div>
}
@for (siteInventory of followUpNotes.siteInventory; track siteInventory) {
<div>
  <ion-grid>
    <ion-row class="inventory-title">
      <ion-col size="10">Inventory Name</ion-col>
      <ion-col size="2">Amount</ion-col>
    </ion-row>
    <ion-row class="inventory-value">
      <ion-col size="10">
        <ion-label>{{siteInventory.name}}</ion-label>
      </ion-col>
      <ion-col size="2">
        <ion-label>{{siteInventory.parLevel}}</ion-label>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12">
        <div class="note">
          Note
          <p>{{siteInventory.note.note}}</p>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
  @if (isFollowUpControlsBlockVisible && siteInventory.note) {
  <div>
    @if (!siteInventory.note.isCompleted) {
  <button class="green"
          (click)="completeUncheckFollowUpNote(siteInventory.note, true, siteInventory.note.isPreviousVisit)"
          [disabled]="global.data.isLoading">
    <ion-icon name="checkmark-circle"></ion-icon>
    Mark as Completed
  </button>
  }
  @if (siteInventory.note.isCompleted) {
  <button class="red"
          (click)="completeUncheckFollowUpNote(siteInventory.note, false, siteInventory.note.isPreviousVisit)"
          [disabled]="global.data.isLoading">
    <ion-icon name="ban"></ion-icon>
    Uncheck
  </button>
  }
  </div>
  }
  <hr/>
</div>
}
@if (followUpNotes.picturesAndNotes.length) {
<div class="data-header">
  Pictures and notes
</div>
}
@for (note of followUpNotes.picturesAndNotes; track note) {
<div>
  <ion-grid>
    <ion-row>
      <ion-col size="12">
        @if (note.img) {
        <ion-img
          class="note-picture"
          [src]="note.img"
          alt="{{note.note}}"
                  ></ion-img>
        }
        @if (isShowImageShareButton && note.filename) {
        <button class="red share-button" (click)="share(note)">
          <ion-icon name="share-social"></ion-icon>
        </button>
        }
        <div class="note">
          Note
          <p>{{note.note}}</p>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
  @if (isFollowUpControlsBlockVisible) {
  <div>
    @if (!note.isCompleted) {
  <button class="green"
          (click)="completeUncheckFollowUpNote(note, true, note.isPreviousVisit)"
          [disabled]="global.data.isLoading">
    <ion-icon name="checkmark-circle"></ion-icon>
    Mark as Completed
  </button>
  }
  @if (note.isCompleted) {
  <button class="red"
          (click)="completeUncheckFollowUpNote(note, false, note.isPreviousVisit)"
          [disabled]="global.data.isLoading">
    <ion-icon name="ban"></ion-icon>
    Uncheck
  </button>
  }
  </div>
  }
  <hr/>
</div>
}
@if (followUpNotes.educationModules.length) {
<div class="data-header">Education Modules</div>
}
@for (note of followUpNotes.educationModules; track note) {
<div class="tsem">
  <ion-grid>
    <ion-row>
      <ion-col>
        <h2>{{note.category}}</h2>
      </ion-col>
    </ion-row>
    @for (comment of note.comments; track comment) {
    <ion-row>
      <ion-col>
        <ion-label class="ion-text-wrap">{{comment.comment}}</ion-label>
                  @for (n of comment.notes; track n) {
    <ion-grid class="notes-grid">
      <ion-row>
        <ion-col size="12">
          @if (n.img) {
          <ion-img
            class="note-picture"
            [src]="n.img"
            alt="{{n.note}}"
                            ></ion-img>
          }
          @if (isShowImageShareButton && n.filename) {
          <button class="red share-button" (click)="share(n)">
            <ion-icon name="share-social"></ion-icon>
          </button>
          }
          <div class="note">
            Note
            <p>{{n.note}}</p>
          </div>
        </ion-col>
      </ion-row>
      @if (isFollowUpControlsBlockVisible) {
      <ion-row>
        <ion-col>
          <div>
            @if (!n.isCompleted) {
      <button class="green"
              (click)="completeUncheckFollowUpNote(n, true, note.isPreviousVisit)"
              [disabled]="global.data.isLoading">
        <ion-icon name="checkmark-circle"></ion-icon>
        Mark as Completed
      </button>
      }
      @if (n.isCompleted) {
      <button class="red"
              (click)="completeUncheckFollowUpNote(n, false, note.isPreviousVisit)"
              [disabled]="global.data.isLoading">
        <ion-icon name="ban"></ion-icon>
        Uncheck
      </button>
      }
      </div>
    </ion-col>
  </ion-row>
      }
    </ion-grid>
    }
    </ion-col>
  </ion-row>
    }
  </ion-grid>
  <hr/>
</div>
}
@if (followUpNotes.services.length) {
<div class="data-header">Services</div>
}
@for (note of followUpNotes.services; track note) {
<div class="tsem">
  <ion-grid>
    <ion-row>
      <ion-col>
        <h2>{{note.category}}</h2>
      </ion-col>
    </ion-row>
    @for (comment of note.comments; track comment) {
    <ion-row>
      <ion-col>
        <ion-label class="ion-text-wrap">{{comment.comment || comment.serviceComment}}</ion-label>
                  @for (n of comment.notes; track n) {
    <ion-grid class="notes-grid">
      <ion-row>
        <ion-col size="12">
          @if (n.img) {
          <ion-img
            class="note-picture"
            [src]="n.img"
            alt="{{n.note}}"
                            ></ion-img>
          }
          @if (isShowImageShareButton && n.filename) {
          <button class="red share-button" (click)="share(n)">
            <ion-icon name="share-social"></ion-icon>
          </button>
          }
          <div class="note">
            Note
            <p>{{n.note}}</p>
          </div>
        </ion-col>
      </ion-row>
      @if (isFollowUpControlsBlockVisible) {
      <ion-row>
        <ion-col>
          <div>
            @if (!n.isCompleted) {
      <button class="green"
              (click)="completeUncheckFollowUpNote(n, true, note.isPreviousVisit)"
              [disabled]="global.data.isLoading">
        <ion-icon name="checkmark-circle"></ion-icon>
        Mark as Completed
      </button>
      }
      @if (n.isCompleted) {
      <button class="red"
              (click)="completeUncheckFollowUpNote(n, false, note.isPreviousVisit)"
              [disabled]="global.data.isLoading">
        <ion-icon name="ban"></ion-icon>
        Uncheck
      </button>
      }
      </div>
    </ion-col>
  </ion-row>
      }
    </ion-grid>
    }
    </ion-col>
  </ion-row>
    }
  </ion-grid>
  <hr/>
</div>
}
@if (followUpNotes.trainings.length) {
<div class="data-header">Trainings</div>
}
@for (note of followUpNotes.trainings; track note) {
<div class="tsem">
  <ion-grid>
    <ion-row>
      <ion-col>
        <h2>{{note.category}}</h2>
      </ion-col>
    </ion-row>
    @for (comment of note.comments; track comment) {
    <ion-row>
      <ion-col>
        <ion-label class="ion-text-wrap">{{comment.comment || comment.trainingComment}}</ion-label>
                  @for (n of comment.notes; track n) {
    <ion-grid class="notes-grid">
      <ion-row>
        <ion-col size="12">
          @if (n.img) {
          <ion-img
            class="note-picture"
            [src]="n.img"
            alt="{{n.note}}"
                            ></ion-img>
          }
          @if (isShowImageShareButton && n.filename) {
          <button class="red share-button" (click)="share(n)">
            <ion-icon name="share-social"></ion-icon>
          </button>
          }
          <div class="note">
            Note
            <p>{{n.note}}</p>
          </div>
        </ion-col>
      </ion-row>
      @if (isFollowUpControlsBlockVisible) {
      <ion-row>
        <ion-col>
          <div>
            @if (!n.isCompleted) {
      <button class="green"
              (click)="completeUncheckFollowUpNote(n, true, note.isPreviousVisit)"
              [disabled]="global.data.isLoading">
        <ion-icon name="checkmark-circle"></ion-icon>
        Mark as Completed
      </button>
      }
      @if (n.isCompleted) {
      <button class="red"
              (click)="completeUncheckFollowUpNote(n, false, note.isPreviousVisit)"
              [disabled]="global.data.isLoading">
        <ion-icon name="ban"></ion-icon>
        Uncheck
      </button>
      }
      </div>
    </ion-col>
  </ion-row>
      }
    </ion-grid>
    }
    </ion-col>
  </ion-row>
    }
  </ion-grid>
  <hr/>
</div>
}
</div>
</div>
}
